import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import PropTypes from 'prop-types';
import { sizes, sizeMap, useId } from './utils';

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.857 15.885l-4.013 3.974a.49.49 0 01-.688 0l-4.013-3.974a.48.48 0 01.344-.822h2.878V4.482c0-.266.218-.482.487-.482h1.296c.269 0 .487.216.487.482v10.581h2.878a.48.48 0 01.344.822z"
});

function LongArrowDown(_ref) {
  let {
    size: sizeProp,
    title,
    titleId
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["size", "title", "titleId"]);

  const size = sizeMap.get(sizeProp);
  titleId = useId(titleId);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size.width,
    height: size.height,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#212429",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

LongArrowDown.sizes = sizes;
LongArrowDown.defaultProps = {
  size: sizes.md
};
LongArrowDown.propTypes = {
  size: PropTypes.oneOf([LongArrowDown.sizes.xs, LongArrowDown.sizes.sm, LongArrowDown.sizes.md, LongArrowDown.sizes.lg, LongArrowDown.sizes.xl]),
  titleId: PropTypes.string,
  title: PropTypes.string.isRequired
};
export default LongArrowDown;